import { createFormStatus, createStaleNotice } from '@avrahami/ui';
import { he } from '../i18n/he';
import { errorMessage } from '../lib/format';

/**
 * The outcome of a save: the API's message (with the "changed by someone else" text for a stale
 * version), or the local "fix the fields" note when the browser already found mistakes.
 */
export const FormStatus = createFormStatus(
  // A versioned save that answers CONFLICT hit a stale version, unless the screen says otherwise.
  (error, overrides) => errorMessage(error, { CONFLICT: he.common.staleVersion, ...overrides }),
  he.common,
);

/** Says that the data changed elsewhere while this form was being edited, with a reload. */
export const StaleNotice = createStaleNotice(he.common);
